<template>
  <div v-if="matchReport" class="container">
    <div class="row mb-2 border-bottom border-secondary pb-1">
      <div class="col-5 p-0 text-end d-flex">
        <div class="text-truncate me-1 w-100">{{ matchReport.team1.name }}</div>
        <team-emblem :emblem-id="matchReport.team1.emblemId" :shadow="true"
                     size="28"/>
      </div>
      <div class="col-2 p-0 text-center result-in-portlet"
           :class="{'live': live}">
        <div>{{ matchReport.goalsTeam1 }}:{{ matchReport.goalsTeam2 }}</div>
      </div>
      <div class="col-5 p-0 text-start d-flex">
        <team-emblem :emblem-id="matchReport.team2.emblemId" :shadow="true"
                     size="28"/>
        <div class="text-truncate ms-1 w-100">{{ matchReport.team2.name }}</div>
      </div>
      <div class="col-12 text-center small live" v-if="live">{{ matchReport.minute }}'</div>
    </div>
    <div class="row" v-if="matchReport.events.length > 0 || matchReport.state !== 'FINISHED'">
      <div class="col-12 border-bottom border-secondary pb-2">
        <div class="row"
             v-for="event in importantEvents"
             :key="event.id">
          <div class="col-4 text-truncate p-0 text-end">
            <div v-if="event.positiveForHome">
              {{ event.ownGoal ? event.negPlayer.surName + ' (ET)' : event.posPlayer.surName }}
              <player-avatar :player="event.ownGoal ? event.negPlayer : event.posPlayer" size="21" class="me-1"/>
            </div>
          </div>
          <div class="col-1 p-0 text-end small live">
            <span v-show="event.positiveForHome">{{ event.minute }}'</span>
          </div>
          <div class="col-2 text-center">{{ event.goalsTeam1 }}:{{ event.goalsTeam2 }}</div>
          <div class="col-1 text-start p-0 small live">
            <span v-show="!event.positiveForHome">{{ event.minute }}'</span>
          </div>
          <div class="col-4 text-truncate p-0">
            <div v-if="!event.positiveForHome">
              <player-avatar :player="event.ownGoal ? event.negPlayer : event.posPlayer" size="21" class="me-1"/>
              {{ event.ownGoal ? event.negPlayer.surName + ' (ET)' : event.posPlayer.surName }}
            </div>
          </div>
        </div>
      </div>
      <div class="event-panel container mt-2">
        <match-event-list :raw-events="matchReport.events" :match-report="matchReport"/>
      </div>
    </div>
    <div v-else class="text-center text-secondary small">
      Zu diesem Spiel liegt leider kein Spielbericht vor.
    </div>
  </div>
</template>

<script>
import PlayerAvatar from "@/components/PlayerAvatar";
import MatchEventList from "@/components/conference/MatchEventList";

export default {
  components: {MatchEventList, PlayerAvatar},
  props: {
    matchId: Number
  },
  data() {
    return {
      matchReport: null
    }
  },
  computed: {
    importantEvents() {
      return this.matchReport.events.filter(e => e.important)
    },
    live() {
      return this.matchReport.state === 'RUNNING'
    }
  },
  methods: {
    loadMatchReport() {
      this.$api.get(`/matchreports/${this.matchId}`).then(response => {
        this.matchReport = response.data
      }).catch(error => this.handleError(error))
    }
  },
  watch: {
    matchId: {
      immediate: true,
      handler() {
        this.loadMatchReport()
      }
    }
  }
}
</script>

<style>
.result-in-portlet {
  font-size: larger;
  font-weight: bold;
}

.event-panel {
  max-height: 30em;
  overflow-y: auto;
}
</style>